// 引入svg
import 'virtual:svg-icons-register'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ids from 'virtual:svg-icons-names'
import { toCenterLine } from '@/utils/tools'
import { iconType } from '@/constant/app.const'
import IconFonts from '@/assets/iconfont/iconfont.json'
import IconFileFonts from '@/assets/fileicon/iconfont.json'

// ## 图标库
// https://icones.netlify.app/
// icon文件夹中的图标 使用 <SvgIcon name="svg_404" />
// 注意前缀是svg_,
// 【svg_文件名】（新建svg文件，复制上面地址中图标为svg格式粘贴到刚才新建的文件中）
// element-icon 使用 <el-icon><component :is="icon" /></el-icon>
// 注意前缀是【el_组件名】（element-plus ui文档中复制）

/**
 * @returns 返回 Element Plus 所有图标的名称数组
 */
export const getElementIconName = () => {
  const elIcons = []
  for (const key in ElementPlusIconsVue) {
    const str = toCenterLine(key)
    elIcons.push(iconType.iconElement + str)
  }
  return elIcons
}

/**
 * @returns 返回本地icon文件夹中svg映射到页面上的id名
 */
export const getIconName = () => {
  return ids.map((item) => iconType.iconSvg + item.substring(5, item.length))
}

/**
 * @returns 返回本地icon文件夹中svg映射到页面上的id名
 */
export const getIconFontName = () => {
  const defaultIcon = IconFonts.glyphs.map((item) => iconType.iconFont + item.font_class)
  const fileIcon = IconFileFonts.glyphs.map((item) => iconType.iconFont + item.font_class)
  return defaultIcon.concat(fileIcon)
}

export const getColorIconFontName = () => {
  const defaultIcon = []
  const fileIcon = IconFileFonts.glyphs.map((item) => iconType.iconColor + item.font_class)
  return defaultIcon.concat(fileIcon)
}

/**
 * @returns 返回所有图标的名称数组
 */
export const getAllIconName = () => {
  return getIconName().concat(getElementIconName()).concat(getIconFontName())
}

/**
 * 安装 Element Plus 所有图标
 * @param app vue实例
 */
const setupElementIcon = (app) => {
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
}

export default setupElementIcon
